
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sumDeliveryFee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchCustomerName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchOrderNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterByStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterOrderDateBetween"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeRangeInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterDeliveryNoteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterExcludeStatus"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryStatusEnum"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterDeliveryArea"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterHasDeliveryNote"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterDestinationHubId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterHubId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QuerySumDeliveryFeeFilterWhereConditions"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterArea"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QuerySumDeliveryFeeFilterAreaWhereHasConditions"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sumDeliveryFee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"searchCustomerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchCustomerName"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchOrderNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchOrderNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterByStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterByStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterOrderDateBetween"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterOrderDateBetween"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterDeliveryNoteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterDeliveryNoteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterExcludeStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterExcludeStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterDeliveryArea"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterDeliveryArea"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterHasDeliveryNote"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterHasDeliveryNote"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterDestinationHubId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterDestinationHubId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterHubId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterHubId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterArea"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterArea"}}}],"directives":[]}]}}],"loc":{"start":0,"end":977}};
    doc.loc.source = {"body":"query sumDeliveryFee(\n  $searchCustomerName: String\n  $searchOrderNumber: String\n  $filterByStatus: String\n  $filterOrderDateBetween: DateTimeRangeInput\n  $filterDeliveryNoteId: Int\n  $filterExcludeStatus: [DeliveryStatusEnum!]\n  $filterDeliveryArea: String\n  $filterHasDeliveryNote: Boolean\n  $filterDestinationHubId: ID\n  $filterHubId: ID\n  $filter: QuerySumDeliveryFeeFilterWhereConditions\n  $filterArea: QuerySumDeliveryFeeFilterAreaWhereHasConditions\n) {\n  sumDeliveryFee(\n    searchCustomerName: $searchCustomerName,\n    searchOrderNumber: $searchOrderNumber\n    filterByStatus: $filterByStatus,\n    filterOrderDateBetween: $filterOrderDateBetween\n    filterDeliveryNoteId: $filterDeliveryNoteId\n    filterExcludeStatus: $filterExcludeStatus\n    filterDeliveryArea: $filterDeliveryArea\n    filterHasDeliveryNote: $filterHasDeliveryNote\n    filterDestinationHubId: $filterDestinationHubId\n    filterHubId: $filterHubId\n    filter: $filter\n    filterArea: $filterArea\n  )\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["sumDeliveryFee"] = oneQuery(doc, "sumDeliveryFee");
        
